const Sdata=[
    {
        imgsrc:"https://picsum.photos/id/222/300/200",
        title:"Web development",
    },
    {
        imgsrc:"https://picsum.photos/id/201/300/200",
        title:"App development",
    },
    {
        imgsrc:"https://picsum.photos/id/202/300/200",
        title:"Software development",
    },
    {
        imgsrc:"https://picsum.photos/id/203/300/200",
        title:"Digital development",
    },
    {
        imgsrc:"https://picsum.photos/id/204/300/200",
        title:"Android development",
    },
    {
        imgsrc:"https://picsum.photos/id/206/300/200",
        title:"Marketing development",
    }
];
export default Sdata;